import { render } from "./Header.vue?vue&type=template&id=228325c6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=228325c6&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228325c6"]])

export default __exports__